import MatchStatusBadge from "./MatchStatusBadge";

function formatDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatDuration(seconds) {
  if (!seconds && seconds !== 0) return "-";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export default function CallLogsPanel({
  callLogs,
  selectedCallLogId,
  onSelect,
}) {
  if (!callLogs.length) {
    return (
      <div className="border rounded-lg p-6 text-center text-gray-500 text-sm">
        No call logs found.
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-4 py-2 border-b">
        <h2 className="text-sm font-semibold text-gray-700">
          UniFi Call Logs
        </h2>
      </div>
      <div className="divide-y max-h-[60vh] overflow-y-auto">
        {callLogs.map((cl) => {
          const matched = !!cl.matched_appointment_id;
          const isSelected = selectedCallLogId === cl.id;

          return (
            <div
              key={cl.id}
              className={`px-4 py-3 flex items-start gap-3 cursor-pointer transition-colors ${
                isSelected
                  ? "bg-blue-50 border-l-2 border-blue-500"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => {
                if (!matched) onSelect(isSelected ? null : cl.id);
              }}
            >
              {/* Radio indicator for unmatched */}
              {!matched && (
                <div className="mt-1 flex-shrink-0">
                  <div
                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                      isSelected
                        ? "border-blue-500"
                        : "border-gray-300"
                    }`}
                  >
                    {isSelected && (
                      <div className="w-2 h-2 rounded-full bg-blue-500" />
                    )}
                  </div>
                </div>
              )}

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-sm text-gray-900">
                    {cl.from_number}
                  </span>
                  <MatchStatusBadge matched={matched} />
                </div>
                <p className="text-xs text-gray-500 mt-0.5">
                  {formatDate(cl.call_datetime)}
                </p>
                <p className="text-xs text-gray-500">
                  Duration: {formatDuration(cl.call_duration_seconds)}
                </p>
                {matched && (
                  <p className="text-xs text-gray-500">
                    Matched to: {cl.matched_patient_name}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
